import {announceFromElement} from '@github-ui/aria-live'
import {useEffect, useRef} from 'react'

export function GitDegradationAdvisory() {
  const advisoryRef = useRef<HTMLSpanElement>(null)
  const hasAnnouncedRef = useRef(false)

  useEffect(() => {
    const element = advisoryRef.current
    if (!element || hasAnnouncedRef.current) return
    announceFromElement(element)
    hasAnnouncedRef.current = true
  }, [])

  return (
    <span ref={advisoryRef}>
      Git services may be degraded. Checking whether this pull request can be merged may take longer than usual.
    </span>
  )
}
